import Network from 'shared/libraries/network';
import CONFIG from 'shared/constants/config';
import { CancelToken } from 'axios';

class TransactionsModel extends Network {
  constructor(baseURL: string, timeout = 120000) {
    super(baseURL, timeout);
  }

  //GET

  async getRespondentTransactions<T>(data: {
    page: string;
    limit: number;
    cancelToken?: CancelToken;
  }): Promise<T> {
    const { cancelToken, ...rest } = data;
    return this.send('get', `transactions/respondent`, {
      params: { ...rest },
      cancelToken,
    });
  }

  async postRespondentTransactionsWithdraw<T>(data: {
    bank_id: number;
  }): Promise<T> {
    return this.send('post', `/transactions/respondent/withdraw`, {
      ...data,
    });
  }
}

const baseUrl: string = CONFIG.REACT_APP_API_BASE_URL as string;
const transactionsModel = new TransactionsModel(baseUrl);
export default transactionsModel;
